/**
 * 跳转到单词学习页（与搜索一致：cell/indexSelect）
 */
export function openWordStudy (router, word, extraQuery) {
  const w = word == null ? '' : String(word).trim()
  if (!w || !router) return
  router.push({
    path: '/indexSelect_display',
    query: Object.assign({ word: w, hideTrans: 'true' }, extraQuery || {})
  })
}

export default { openWordStudy }



// WEBPACK FOOTER //
// ./src/utils/openWordStudy.js